import { render, staticRenderFns } from "./combine.vue?vue&type=template&id=31af4608&scoped=true&"
import script from "./combine.vue?vue&type=script&lang=js&"
export * from "./combine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31af4608",
  null
  
)

export default component.exports